<template>
<div class="recommend-service">
  <Tab :tabList="serviceTabs" v-slot="data" @clickTab="onClickTab">
    <div
      v-if="themeLists[data.tabIndex]"
      :key="themeLists[data.tabIndex].themeId"
      class="service-list"
      v-stat.brow="{
        tag: 'service_list.tab_content|推荐服务列表Tab内容',
        ext: { fservicetabid: themeLists[data.tabIndex].themeId },
      }"
    >
      <ThemeCard
        class="theme-card"
        v-for="card in themeLists[data.tabIndex].list"
        :key="card.title"
        :cardInfo="card"
        @themeCardClick="onClickCustomEvent"
        :isShowCardDesc="false"
      ></ThemeCard>
    </div>
  </Tab>
  <!-- 地铁说明弹窗 -->
  <SubwayTipDialog ref="subwayTipDialog"></SubwayTipDialog>
</div>
</template>

<script setup lang="ts">
import { getTravelAssistant } from '@/store';
import { useRouter } from 'vue-router/composables';
import Tab from './tab.vue';
import ThemeCard from '@/components/common/theme/theme-card.vue';
import SubwayTipDialog from '@/components/dialog/subway-tip-dialog.vue';
import { onBeforeMount, ref, computed } from 'vue';
import { ThemeList } from '@/types';
import { biClick } from '@tencent/fit-bi-sdk';
import { CustomEventKey } from '@/types/merchant';
const emit = defineEmits(['onHideModule']);

const router = useRouter();
// 地铁弹窗
const subwayTipDialog = ref<InstanceType<typeof SubwayTipDialog> | null>(null);

const themeLists = ref<ThemeList[]>([]);
const isReady = ref(false);

const serviceTabs = computed(() => themeLists.value.map(item => item.title));

const onClickTab = (tabIndex: number) => {
  biClick('service_list.tab|推荐服务列表Tab', { fservicetabid: themeLists.value[tabIndex].themeId });
};

// 处理自定义事件
function onClickCustomEvent(key: string) {
  // 地铁说明弹窗
  if (key === CustomEventKey.subway) {
    subwayTipDialog.value?.onShowDialog();
  }
  // 点击"全部"
  if (key === CustomEventKey.all) {
    router.push({ name: 'merchantDetail' });
  }
}

onBeforeMount(async () => {
  const serviceList = await getTravelAssistant();
  themeLists.value = (serviceList as ThemeList[]) || [];
  isReady.value = true;
});
</script>

<style lang="less" scoped>
@import (reference) '~@/less/main.less';
.service-list {
  width: 100%;
  min-height: 288/@rem;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 6/@rem 0 32/@rem 0;
  /deep/ .theme-card {
    width: 20%;
    padding-top: 24/@rem;
    &-wrapper {
      text-align: center;
      .title {
        .font-24-regular();
      }
    }
  }
}
</style>
